module.exports = __webpack_public_path__ + "img/sofia-bulgaria-2-million-people.0ad6f3be.jpg";